import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, Subscription } from 'rxjs';
import { getData, getDetalleVarTemp, getPeriodosAT } from './querys';
import { Apollo } from 'apollo-angular';
import { environment } from '../../../../../environments/environment.development';
import { getCoberturaRiesgos } from './querysRiesgoGeneral';
import { getDetalleIndicadores, getIndicadores } from '../../../financiero/indicadores-financieros/querys';

@Injectable({
  providedIn: 'root'
})
export class GraphATService {
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private querySubscription: Subscription;
  constructor(
    private cookies: CookieService,
    private apollo: Apollo,
  ) { }

  public async getEvaluaciones(idPlantilla: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getPeriodosAT,
        context: {headers: this.headers},
        variables: { idPlantilla: idPlantilla }
      }).valueChanges
    );
    return data.evaluaciones;
  }
  public async getDatos(periodo: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getData,
        context: {headers: this.headers},
        variables: {"periodo": periodo}
      }).valueChanges
    );
    return data.tabla_Amortizacion_sub_calculos;
  }
  public async getDetalleVarTemporales(idEvaluacion: number, idVT: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getDetalleVarTemp,
        context: {headers: this.headers},
        variables: {idEvaluacion: idEvaluacion, idVarTemp: idVT}
      }).valueChanges
    );
    return data.detalleEvaluacionVarTemp.valor
  }
  public async getDatosRiesgos(idInstitucion: string, periodo: {mes:number, anio:number}){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getCoberturaRiesgos,
        context: {headers: this.headers},
        variables: {periodo: periodo, idInstitucion: idInstitucion}
      }).valueChanges
    );
    return data.obtenerCobertura;    
  }
  public async getDataIndicadores(plantilla: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getIndicadores,
        context: { headers: this.headers, },
        variables: { idPlantilla: plantilla }
      }).valueChanges
    );
    return data.indicadores;
  }
}
